
import Vue from "vue";

interface DropdownItem {
	text: string;
	value: string;
}

export default Vue.extend({
	props: {
		icon: String,
		disabled: Boolean,
		light: Boolean,
		tooltip: String,
		items: Array as () => DropdownItem[],
		up: Boolean
	},
	methods: {
		onClick(){
			if (this.disabled) return;
			this.$emit("click");
		},
		onItemClick(value: string){
			this.$emit("action", value);
		}
	}
});
